import { Dialog } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { AnimatePresence, motion } from 'framer-motion'

export default function SideModal({
  isOpen,
  setIsOpen,
  title,
  maxWidth,
  children,
}) {
  return (
    <AnimatePresence>
      {isOpen && (
        <Dialog
          open={isOpen}
          onClose={() => setIsOpen(false)}
          className="relative z-50"
        >
          {/* Animated Backdrop with Click-to-Close */}
          <motion.div
            className="hidden sm:block fixed inset-0 w-full bg-foreground/50 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={() => setIsOpen(false)}
          />

          {/* Sliding Panel */}
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{
              animate: {
                type: 'spring',
                stiffness: 500,
                damping: 30,
                duration: 0.2,
              },
              exit: { type: 'tween', duration: 0.2 },
            }}
            className={`fixed inset-y-0 right-0 z-30 overflow-y-auto bg-background border-l-2 border-foreground w-full max-w-${maxWidth}`}
          >
            {/* Header */}
            <div className="sticky top-0 z-10 h-20 px-4 md:px-6 flex items-center justify-between border-b-2 border-foreground bg-background">
              <h3 className="text-xl md:text-2xl font-bold font-serif text-foreground tracking-tight">
                {title}
              </h3>
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="rounded-sm p-2 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
                aria-label="Close modal"
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon aria-hidden="true" className="h-6 w-6" />
              </button>
            </div>

            {/* Content */}
            <div>{children}</div>
          </motion.div>
        </Dialog>
      )}
    </AnimatePresence>
  )
}
